import React, { useEffect, useState } from "react";
import BasicDetails from "../../components/AddUsers/UserDetails/BasicDetails/BasicDetails";
import LoggedInUserPersonalDetails from "../../components/MySpace/ProfileDetails/LoggedInUserPersonalDetails";
import Communications from "../../components/AddUsers/UserDetails/Communications/Communications";
import LoggedInuserPersonalAddress from "../../components/MySpace/ProfileDetails/LoggedInuserPersonalAddress";
import OnlinePresenc from "../../components/AddUsers/UserDetails/OnlinePresenc/OnlinePresenc";
import ProfilePhoto from "../../components/Profile/UserDetails/ProfilePhoto";

import Select from "react-select";
import { CalenderIcon } from "../../components/Icon";
import DatePicker from "react-datepicker";
import { Label } from "reactstrap";
import moment from "moment";
import {
  CircularAvatar,
  CommonHeader,
  ErrorSuccessModal,
  Loader,
} from "../../components/commons";
import FixedAssetDetails from "../../components/AddUsers/UserDetails/FixedAssetDetails/FixedAssetDetails";
import { UserProfileType } from "../../redux/auth/authTypes";
import { RootState } from "../../redux/rootReducers";
import { connect } from "react-redux";
import { updateProfile } from "../../redux/usersProfile/actions";
import {
  GetCityListDataPayloadType,
  GetCountryListDataPayloadType,
  GetStateListDataPayloadType,
} from "../../commonTypes/masterDataTypes";
import {
  getAllCityAction,
  getAllCountryAction,
  getAllStateAction,
  resetCityList,
  resetStateList,
} from "../../redux/masterData";
import Address from "../../components/AddUsers/UserDetails/Address/Address";
import { components } from "react-select";
import {
  CityListTypes,
  CountryListTypes,
  StateListTypes,
} from "../../redux/masterData/masterTypes";
import { OptionsType } from "../../commonTypes/universalTypes";
import useDebounce from "../../customHooks/useDebounce";
import {
  checkUniqueMobileNoAction,
  resetAuthError,
  resetIsMobileNo,
  resetMobileError,
  resetMobileFetching,
  resetMobileMessage,
  resetSession,
} from "../../redux/auth";
import { CheckUniquiEmailAndMobilePayloadType } from "../../commonTypes/authTypes";
import toast, { Toaster } from "react-hot-toast";
import {
  formatDate,
  isEmailValid,
  reverseDate,
} from "../../utils/commonFunctions";
import { resetUsersProfileError, resetUsersProfileMessage } from "../../redux/usersProfile";
type UniqueMobileNoType = {
  token: string | null;
  operation: string | null;
  mobile: number | null | undefined;
};
export const accordianJobDetails = [
  {
    is_default: false,
    isOpen: true,
    isDeleteIcon: false,
    job_info: {
      employee_id: null,
      job_title: "",
      department: {
        label: "Select..",
        value: null,
      },
      start_date: null,
      probation_end_date: null,
      end_date: null,
      total_experience: "",
      rejoin_date: null,
      date_of_notice: null,
      date_of_relieve: null,
      date_of_conformation: null,
      client: null,
      show_client: null,
    },
    reporting_details: {
      it_assets_assigned: "",
      reporting_person: null,
      show_reporting_person: null,
      coach: null,
      show_coach: null,
      far_assigned_details: [],
    },
    file_attachment: [],
    emailer_settings: [],
    show_emailer_settings: [],
  },
];
type AppProps = {
  history: any;
  dispatchUpdateProfile: (data: any) => void;
  token: string | null;
  dispatchResetCityList: () => void;
  dispatchGetCountryListAction: (data: GetCountryListDataPayloadType) => void;
  dispatchGetAllStateAction: (data: GetStateListDataPayloadType) => void;
  dispatchResetStateList: () => void;
  countryListTotalCount: number;
  countryList: CountryListTypes[] | [];
  countryFetching: boolean;
  stateList: StateListTypes[] | [];
  stateFetching: boolean;
  cityList: CityListTypes[] | [];
  cityListTotalCount: number;
  isState: null | boolean;
  isCity: null | boolean;
  stateListTotalCount: number;
  dispatchGetAllCityAction: (data: GetCityListDataPayloadType) => void;
  dispatchResetMobileError: () => void;
  dispatchResetMobileMessage: () => void;
  dispatchResetMobileFetching: () => void;
  dispatchResetIsMobileNo: () => void;
  dispatchCheckUniqueMobileNoAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => void;
  mobileMessage: string | null;
  mobileFetching: boolean;
  isMobileNo: number | null;
  fetching: boolean;
  statusCode: number | null;
  error: string | null;
  success: number | null;
  message: null | string;
  dispatchResetSession: () => void;
  dispatchResetAuthError: () => void;
  dispatchResetUsersProfileError: () => void;
  dispatchResetUsersProfileMessage: () => void;
};

const LoggedInUserProfileDetails = ({
  history,
  dispatchUpdateProfile,
  token,
  dispatchResetCityList,
  dispatchGetCountryListAction,
  dispatchGetAllStateAction,
  dispatchResetStateList,
  countryListTotalCount,
  countryList,
  countryFetching,
  stateList,
  stateFetching,
  cityList,
  cityListTotalCount,
  isState,
  isCity,
  stateListTotalCount,
  dispatchGetAllCityAction,
  dispatchResetMobileError,
  dispatchResetMobileMessage,
  dispatchResetMobileFetching,
  dispatchResetIsMobileNo,
  dispatchCheckUniqueMobileNoAction,
  mobileMessage,
  mobileFetching,
  isMobileNo,
  fetching,
  statusCode,
  error,
  success,
  message,
  dispatchResetSession,
  dispatchResetAuthError,
  dispatchResetUsersProfileError,
  dispatchResetUsersProfileMessage
}: AppProps) => {
  const data = history?.location?.state;
  const user_id = history?.location?.userId;
  let isDefaultEmployee = data?.job_details?.find(
    (jobDetails: any) => jobDetails?.is_default === true
  );

  let reportingPersonFirstName = isDefaultEmployee?.reporting_details
    ?.reporting_person?.first_name
    ? isDefaultEmployee?.reporting_details?.reporting_person?.first_name
    : "";

  let reportingPersonLastName = isDefaultEmployee?.reporting_details
    ?.reporting_person?.last_name
    ? isDefaultEmployee?.reporting_details?.reporting_person?.last_name
    : "";
  const [countrySelectedList, setCountrySelectedList] = useState<any>([]);
  const [countryoffset, setCountryOffset] = useState<number>(0);
  const [stateOffset, setStateOffset] = useState<number>(0);
  const [cityOffset, setCityOffset] = useState<number>(0);
  const [countrytext, setCountryText] = useState<string>("");
  const [stateText, setStateText] = useState<string>("");
  const [cityText, setCityText] = useState<string>("");
  const [countrylimit, setCountryLimit] = useState<number>(20);
  const [finalStateList, setFinalStateList] = useState<any>([]);
  const [finalCityList, setFinalCityList] = useState<any>([]);

  const [addressState, setAddressState] = useState<OptionsType>({
    value: null,
    label: "Choose State...",
  });
  const [selectedCityList, setSelectedCityList] = useState<any>({
    value: null,
    label: "Select...",
  });
  const [isApiCityCall, setIsApiCityCall] = useState(false);
  const [uniqueMobileNo, setUniqueMobileNo] = useState<UniqueMobileNoType>({
    token,
    operation: "update",
    mobile: null,
  });
  const [profileForm, setProfileForm] = useState<UserProfileType>({
    type: "internal-user",
    user_details: {
      profile_pic: null,
      basic_details: {
        first_name: "",
        last_name: "",
        email_id: "",
        access_details: {
          status: "",
          assigned_group: null,
          password: "",
        },
        skill: [],
      },
      personal_details: {
        gender: "",
        date_of_birth: "",
        blood_group: "",
        qualifications: "",
        mother_name: "",
        martial_status: "",
        spouse_name: "",
        father_or_husband_name: "",
        about_me: "",
      },
      current_address: {
        address_line1: "",
        address_line2: "",
        city: {
          value: null,
          label: "Select",
        },
        state: {
          value: null,
          label: "Select",
        },
        postal_code: "",
        country: {
          value: null,
          label: "Select",
        },
      },
      permanent_address: {
        address_line1: "",
        address_line2: "",
        city: {
          value: null,
          label: "Select",
        },
        state: {
          value: null,
          label: "Select",
        },
        postal_code: "",
        country: {
          value: null,
          label: "Select",
        },
      },
      contact_details: {
        personal_email_id: "",
        mobile: "",
        whatsapp_number: "",
        work_phone: "",
        emergency_contact_person: "",
        emergency_contact_number: "",
      },
      online_presence: {
        twitter_id: "",
        linkedin_profile: "",
      },
    },
    hr_settings: {
      leave_balance: null,
      work_from_home_balance: null,
      working_days: null,
      employment_status: "",
      is_govt_officer: false,
      work_details: {
        user_branch: null,
        // hourly_charge: "",
        // standard_hour: "",
        is_partner_field: "",
        is_manager_field: "",
        is_track_scheduling: "",
        is_track_efficiency: "",
      },
    },
    job_details: [],
    payroll_settings: {
      identification_details: {
        passport_number: "",
        passport_expiry: "",
        adhar_number: "",
        pan: "",
        uan_number: "",
        entity_name: "",
        pan_details: null,
      },
      bank_account_details: [
        {
          bank_name: "",
          branch_name: "",
          bank_account_number: "",
          ifsc_code: "",
          account_type: "",
          bank_verification_details: null,
        },
      ],
      hourly_charge: "",
      standard_hour: "",
    },
    user_settings: {
      is_track_aproved_entries: false,
      total_target_entries: null,
      is_disable_user: false,
    },
  });
  const [accordianJobDetailsData, setAccordianJobDetailsData] = useState(
    JSON.parse(JSON.stringify(accordianJobDetails))
  );
  const [finalCountry, setCountry] = useState<any>({
    value: null,
    label: "Select..",
  });
  const [profileDetailsError, setProfileDetailsError] = useState({
    nameError: "",
    emailError: "",
    newPasswordError: "",
    newPasswordAgainError: "",
    countryError: "",
    stateError: "",
    cityError: "",
  });

  const [isApiCall, setIsApiCall] = useState(false);
  const [limit, setLimit] = useState(20);



  useEffect(() => {
    dispatchResetUsersProfileMessage();
    dispatchResetMobileMessage();
    dispatchResetMobileFetching();
    dispatchResetIsMobileNo();
  }, []);

  useEffect(() => {
    if (data) {
      setProfileForm({ ...data });
    }
  }, [
    data,
    data?.job_details,
    data?.user_details,
    data?.user_details?.basic_details,
    data?.hr_settings,
    data?.user_details?.basic_details?.access_details,
    data?.payroll_settings,
  ]);

  useEffect(() => {
    if (data) {
      let skillValue =
        data?.user_details?.basic_details?.skill &&
        data?.user_details?.basic_details?.skill?.map((i: any) => {
          return {
            value: i?._id,
            label: i?.skill_name,
          };
        });

      setProfileForm({ ...data });
      {
        skillValue &&
          setProfileForm((prv: any) => {
            return {
              ...prv,
              user_details: {
                ...prv.user_details,
                basic_details: {
                  ...prv.user_details.basic_details,
                  skill: skillValue,
                },
              },
            };
          });
      }

      if (data?.job_details?.length) {
        let arr: any[] = [];
        data?.job_details?.map((item: any) => {
          arr.push({
            is_default: item?.is_default,
            isOpen: true,
            isDeleteIcon: false,
            job_info: {
              employee_id: item?.job_info?.employee_id,
              job_title: item?.job_info?.job_title,
              department: {
                label: item?.job_info?.department?.department_name
                  ? item?.job_info?.department?.department_name
                  : "Select..",
                value: item?.job_info?.department?._id
                  ? item?.job_info?.department?._id
                  : null,
              },
              external_department: item?.job_info?.external_department,
              start_date: item?.job_info?.start_date
                ? item?.job_info?.start_date?.split("T")[0]
                : null,
              probation_end_date: item?.job_info?.probation_end_date
                ? item?.job_info?.probation_end_date?.split("T")[0]
                : null,
              end_date: item?.job_info?.end_date
                ? item?.job_info?.end_date?.split("T")[0]
                : null,
              total_experience: item?.job_info?.total_experience,
              rejoin_date: item?.job_info?.rejoin_date
                ? item?.job_info?.rejoin_date?.split("T")[0]
                : null,
              date_of_notice: item?.job_info?.date_of_notice
                ? item?.job_info?.date_of_notice?.split("T")[0]
                : null,
              date_of_relieve: item?.job_info?.date_of_relieve
                ? item?.job_info?.date_of_relieve?.split("T")[0]
                : null,
              date_of_conformation: item?.job_info?.date_of_conformation
                ? item?.job_info?.date_of_conformation?.split("T")[0]
                : null,
              client: item?.job_info?.client ? item?.job_info?.client : null,
              show_client: item?.job_info?.client_details?.client_code
                ? {
                  label: `${item?.job_info?.client_details?.company_name}(${item?.job_info?.client_details?.client_code})`,
                  value: item?.job_info?.client_details?.client_code,
                }
                : { label: "Select", value: null },
            },
            reporting_details: {
              it_assets_assigned: item?.reporting_details?.it_assets_assigned,
              far_assigned_details:
                item?.reporting_details?.far_assigned_details?.length > 0
                  ? item?.reporting_details?.far_assigned_details?.map(
                    (item: any) => ({
                      ...item,
                      far_it_assets_assigned: {
                        value: item?.far_it_assets_assigned?.far_id,
                        label:
                          item?.far_it_assets_assigned?.asset_description,
                      },
                    })
                  )
                  : [],
              reporting_person:
                item?.reporting_details?.reporting_person?.user_id,
              show_reporting_person: item?.reporting_details?.reporting_person
                ?.user_id
                ? {
                  label: `${item?.reporting_details?.reporting_person?.first_name
                    } ${item?.reporting_details?.reporting_person?.last_name
                      ? item?.reporting_details?.reporting_person?.last_name
                      : ""
                    }`,
                  value: item?.reporting_details?.reporting_person?.user_id,
                }
                : { label: "Select", value: null },
              coach: item?.reporting_details?.coach?.user_id,
              show_coach: item?.reporting_details?.coach?.user_id
                ? {
                  label: `${item?.reporting_details?.coach?.first_name} ${item?.reporting_details?.coach?.last_name
                    ? item?.reporting_details?.coach?.last_name
                    : ""
                    }`,
                  value: item?.reporting_details?.coach?.user_id,
                }
                : { label: "Select", value: null },
            },
            file_attachment: item?.file_attachment,
            show_emailer_settings: item?.emailer_settings?.length
              ? item?.emailer_settings?.map((email: any) => {
                return {
                  label: email?.email_name,
                  value: email?._id,
                };
              })
              : [],
            emailer_settings: item?.emailer_settings?.length
              ? item?.emailer_settings?.map((email: any) => email?._id)
              : [],
          });
        });
        setAccordianJobDetailsData(arr);
      } else {
        setAccordianJobDetailsData(
          JSON.parse(JSON.stringify(accordianJobDetails))
        );
      }
      // setAccordianJobDetailsData

      // let status = data?.user_details?.basic_details?.access_details?.status === true ? true : false;
    }
  }, [
    data,
    data?.job_details,
    data?.user_details,
    data?.user_details?.basic_details,
    data?.hr_settings,
    data?.user_details?.basic_details?.access_details,
    data?.payroll_settings,
  ]);
  useEffect(() => {
    if (profileForm?.hr_settings?.employment_status === "Probation") {
      let temp = accordianJobDetailsData;
      temp?.forEach((el: any, index: number) => {
        if (el?.job_info?.start_date && !el?.job_info?.probation_end_date) {
          el["job_info"].probation_end_date = moment(el?.job_info?.start_date)
            .add(6, "months")
            .format("YYYY-MM-DD");
        }
      });
      setAccordianJobDetailsData?.([...temp]);
      // }
    }
  }, [profileForm?.hr_settings?.employment_status]);

  useEffect(() => {
    dispatchResetCityList();
    if (profileForm?.user_details?.current_address?.country?.value) {
      let finalData: GetStateListDataPayloadType = {
        token,
        limit,
        offset: stateOffset,
        search_term: stateText,
        country_id: profileForm?.user_details?.current_address?.country?.value,
      };

      if (stateOffset === 0) {
        dispatchGetAllStateAction(finalData);

        setIsApiCall(true);
      } else {
        dispatchGetAllStateAction(finalData);
        setStateOffset(0);
        setIsApiCall(true);
      }
    }
  }, [profileForm?.user_details?.current_address?.country?.value]);

  useEffect(() => {
    const finalCityData = cityList?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (cityOffset > 0) {
      setFinalCityList([...finalCityList, ...finalCityData]);
    } else {
      setFinalCityList(finalCityData);
    }
  }, [cityList]);

  useEffect(() => {
    const finalStateData = stateList?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (stateOffset > 0) {
      setFinalStateList([...finalStateList, ...finalStateData]);
    } else {
      setFinalStateList(finalStateData);
    }
  }, [stateList]);

  useEffect(() => {
    const finalCountryData = countryList?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (countryoffset > 0) {
      setCountrySelectedList([...countrySelectedList, ...finalCountryData]);
    } else {
      setCountrySelectedList(finalCountryData);
    }
  }, [countryList]);

  useDebounce(
    () => {
      if (profileForm.user_details.contact_details.mobile) {
        dispatchCheckUniqueMobileNoAction(uniqueMobileNo);
      }
    },
    500,
    [uniqueMobileNo]
  );

  useEffect(() => {
    dispatchResetCityList();
    if (token && stateOffset != 0) {
      let finalStateData = {
        token,
        offset: stateOffset,
        limit,
        search_term: stateText,
        country_id: profileForm?.user_details?.current_address?.country?.value,
      };
      if (stateOffset <= stateListTotalCount) {
        dispatchGetAllStateAction(finalStateData);
      }
    }
  }, [stateOffset]);
  useDebounce(
    () => {
      if (stateText && isApiCall) {
        fetchData(stateText);
      } else if (isApiCall) {
        const finalData = {
          token,
          offset: stateOffset,
          limit,
          search_term: stateText,
          country_id:
            profileForm?.user_details?.current_address?.country?.value,
        };
        dispatchGetAllStateAction(finalData);
      }
    },
    500,
    [stateText]
  );

  const fetchData = (search: string) => {
    const finalData = {
      token,
      offset: stateOffset,
      limit,
      search_term: stateText,
      country_id: profileForm?.user_details?.current_address?.country?.value,
    };

    dispatchGetAllStateAction(finalData);
  };
  useEffect(() => {
    dispatchResetCityList();
    dispatchResetStateList();
    if (token) {
      let finalCountryData = {
        token,
        offset: countryoffset,
        limit: countrylimit,
        search_term: countrytext,
      };
      if (countryoffset <= countryListTotalCount) {
        dispatchGetCountryListAction(finalCountryData);
      }
    }
  }, [countryoffset]);

  const fetchNewCountryData = (search: string) => {
    const finalData = {
      token,
      offset: countryoffset,
      limit: countrylimit,
      search_term: countrytext,
    };
    dispatchGetCountryListAction(finalData);
  };

  useDebounce(
    () => {
      if (countrytext) {
        fetchNewCountryData(countrytext);
      } else {
        const finalData = {
          token,
          offset: countryoffset,
          limit: countrylimit,
          search_term: countrytext,
        };
        dispatchGetCountryListAction(finalData);
      }
    },
    500,
    [countrytext]
  );

  useEffect(() => {
    dispatchResetCityList();
    if (
      isState === false &&
      !stateFetching &&
      profileForm?.user_details?.current_address?.country?.value
    ) {
      let finalData: GetCityListDataPayloadType = {
        token,
        limit,
        offset: cityOffset,
        search_term: cityText,
        country_id: profileForm?.user_details?.current_address?.country?.value,
      };
      if (cityOffset === 0) {
        dispatchGetAllCityAction(finalData);
      } else {
        setCityOffset(0);
      }
    }
  }, [isState]);
  useEffect(() => {
    let finalData: GetCityListDataPayloadType = {
      token,
      limit,
      offset: cityOffset,
      search_term: cityText,
      state_id: profileForm?.user_details?.current_address?.state?.value,
    };
    if (profileForm?.user_details?.current_address?.state?.value) {
      if (cityOffset === 0) {
        dispatchGetAllCityAction(finalData);
        setIsApiCityCall(true);
      } else {
        dispatchGetAllCityAction(finalData);
        setCityOffset(0);
        setIsApiCityCall(true);
      }
    }
  }, [profileForm?.user_details?.current_address?.state?.value]);

  useEffect(() => {
    if (token && cityOffset !== 0) {
      let finalcityData = {
        token,
        offset: cityOffset,
        limit,
        search_term: cityText,
        state_id: profileForm?.user_details?.current_address?.state?.value,
      };
      if (cityOffset <= cityListTotalCount) {
        dispatchGetAllCityAction(finalcityData);
      }
    }
  }, [cityOffset]);

  useEffect(() => {

    if (profileForm?.user_details?.contact_details?.personal_email_id?.length && !isEmailValid(profileForm?.user_details?.contact_details?.personal_email_id)) {
      setProfileDetailsError((prv: any) => {
        return {
          ...prv,
          emailError: "Please enter a valid email",
        };
      });

    } else {
      setProfileDetailsError((prv: any) => {
        return {
          ...prv,
          emailError: "",
        };
      });
    }
  }, [profileForm?.user_details?.contact_details?.personal_email_id
  ])

  const fetchCityData = (search: string) => {
    const finalData = {
      token,
      offset: cityOffset,
      limit,
      search_term: cityText,
      state_id: profileForm?.user_details?.current_address?.state?.value,
    };
    dispatchGetAllCityAction(finalData);
  };

  useDebounce(
    () => {
      if (cityText && isApiCityCall) {
        fetchCityData(cityText);
      } else if (isApiCityCall) {
        const finalData = {
          token,
          offset: cityOffset,
          limit,
          search_term: cityText,
          state_id: profileForm?.user_details?.current_address?.state?.value,
        };
        dispatchGetAllCityAction(finalData);
      }
    },
    500,
    [cityText]
  );

  //handle personal Details
  function handlePersonalDetails(e: any) {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        user_details: {
          ...prv.user_details,
          personal_details: {
            ...prv.user_details.personal_details,
            [e.target.name]: e.target.value,
          },
        },
      };
    });
  }
  const handleAddressDetails = (e: any) => {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        user_details: {
          ...prv.user_details,
          current_address: {
            ...prv.user_details.current_address,
            [e.target.name]: e.target.value,
          },
        },
      };
    });
  };


  const handleSubmit = async () => {
    let tempData = JSON.parse(JSON.stringify(accordianJobDetailsData));
    tempData?.forEach((item: any) => {
      item.is_default = item?.is_default;
      item.job_info.employee_id = item?.job_info?.employee_id;
      item.job_info.job_title = item?.job_info?.job_title?.trim();
      item.job_info.department = {
        id: item?.job_info?.department?.value,
        name: item?.job_info?.department?.value
          ? item?.job_info?.department?.label
          : "",
      };
      item.job_info.external_department = item?.job_info?.external_department;
      item.job_info.start_date = item?.job_info?.start_date
        ? reverseDate(item?.job_info?.start_date)
        : null;
      item.job_info.probation_end_date = item?.job_info?.probation_end_date
        ? reverseDate(item?.job_info?.probation_end_date)
        : null;
      item.job_info.end_date = item?.job_info?.end_date
        ? reverseDate(item?.job_info?.end_date)
        : null;
      item.job_info.total_experience = item?.job_info?.total_experience?.trim();
      item.job_info.rejoin_date = item?.job_info?.rejoin_date
        ? reverseDate(item?.job_info?.rejoin_date)
        : null;
      item.job_info.date_of_notice = item?.job_info?.date_of_notice
        ? reverseDate(item?.job_info?.date_of_notice)
        : null;
      item.job_info.date_of_relieve = item?.job_info?.date_of_relieve
        ? reverseDate(item?.job_info?.date_of_relieve)
        : null;
      item.job_info.date_of_conformation = item?.job_info?.date_of_conformation
        ? reverseDate(item?.job_info?.date_of_conformation)
        : null;
      item.job_info.client = item?.job_info?.client
        ? item?.job_info?.client
        : null;
      item.reporting_details.it_assets_assigned =
        item?.reporting_details?.it_assets_assigned?.trim();
      item.reporting_details.far_assigned_details =
        item?.reporting_details?.far_assigned_details?.map((item: any) => ({
          far_it_assets_assigned: {
            far_id: item?.far_it_assets_assigned?.value,
            asset_description: item?.far_it_assets_assigned?.label,
          },
          far_start_date: item?.far_start_date
            ? formatDate(item?.far_start_date)
            : null,
          far_end_date: item?.far_end_date
            ? formatDate(item?.far_end_date)
            : null,
        }));
      item.reporting_details.reporting_person = item?.reporting_details
        ?.reporting_person
        ? item?.reporting_details?.reporting_person
        : null;
      item.reporting_details.coach = item?.reporting_details?.coach
        ? item?.reporting_details?.coach
        : null;
      item.reporting_details.show_coach = null;
      item.file_attachment = item?.file_attachment;
      item.emailer_settings = item?.emailer_settings?.length
        ? item.emailer_settings
        : [];
      delete item.isOpen;
      delete item.isDeleteIcon;
      delete item.job_info.show_client;
      delete item.reporting_details.show_reporting_person;
      delete item.show_emailer_settings;
      delete item.reporting_details.show_coach;
    });
    const checkMandatoryInItAssets = () => {
      let flag = true;
      tempData?.map((item: any) => {
        item.reporting_details?.far_assigned_details?.map((item: any) => {
          if (
            item?.far_start_date &&
            item?.far_start_date !== null &&
            item?.far_it_assets_assigned?.far_id
          ) {
          } else {
            flag = false;
            return;
          }
        });
      });
      return flag;
    };

    let enCurrentPassword;
    if (profileForm?.user_details?.basic_details?.access_details?.password) {
    }
    if (
      profileForm.user_details.basic_details.first_name?.trim() &&
      profileForm.user_details.basic_details.email_id?.trim() &&
      isEmailValid(profileForm.user_details.basic_details.email_id) &&
      checkMandatoryInItAssets() &&
      ((isState &&
        profileForm?.user_details?.current_address?.state &&
        profileForm?.user_details?.current_address?.country?.value &&
        profileForm?.user_details?.current_address?.city?.value) ||
        (!isState &&
          profileForm?.user_details?.current_address?.country?.value) ||
        (isState &&
          profileForm?.user_details?.current_address.state?.value &&
          profileForm?.user_details?.current_address?.country?.value &&
          !isCity)) &&
      // profileForm?.user_details?.basic_details?.access_details?.password?.trim() &&
      // newPassword.trim() &&
      // profileForm?.user_details?.basic_details?.access_details?.password.trim() &&
      // newPassword ===
      // profileForm?.user_details?.basic_details?.access_details?.password &&
      // !Object.values(passwordResult).includes(false) &&
      !mobileMessage?.includes("mobile")
    ) {
      if (token) {
        let dateOfBirth = profileForm?.user_details?.personal_details
          ?.date_of_birth
          ? profileForm?.user_details?.personal_details?.date_of_birth
          : null;
        let passportExpiry = profileForm?.payroll_settings
          ?.identification_details?.passport_expiry
          ? profileForm?.payroll_settings?.identification_details
            ?.passport_expiry
          : null;
        let userBranch = profileForm?.hr_settings?.work_details?.user_branch
          ? profileForm?.hr_settings?.work_details?.user_branch
          : profileForm?.hr_settings?.work_details?.user_branch
            ? profileForm?.hr_settings?.work_details?.user_branch
            : null;
        if (userBranch) {
          userBranch = {
            branch_id: userBranch._id,
            branch_name: userBranch.branch_name,
          };
        }
        let skillsID = profileForm?.user_details?.basic_details?.skill?.map(
          (id: any) => id.value
        );
        let newData = {
          ...profileForm,
          user_details: {
            ...profileForm.user_details,
            current_address: {
              ...profileForm?.user_details?.current_address,
              city: profileForm?.user_details?.current_address?.city?.label,
              state: profileForm?.user_details?.current_address?.state?.label,
              country:
                profileForm?.user_details?.current_address?.country?.label,
            },
            permanent_address: {
              ...profileForm?.user_details?.permanent_address,
              city: profileForm?.user_details?.permanent_address?.city?.label,
              state: profileForm?.user_details?.permanent_address?.state?.label,
              country:
                profileForm?.user_details?.permanent_address?.country?.label,
            },

            basic_details: {
              ...profileForm.user_details.basic_details,
              first_name:
                profileForm.user_details.basic_details.first_name?.trim(),
              last_name:
                profileForm.user_details.basic_details.last_name?.trim(),
              access_details: {
                ...profileForm.user_details.basic_details.access_details,
                status: true,
                password: enCurrentPassword,
              },
              skill: skillsID,
            },
            personal_details: {
              ...profileForm.user_details.personal_details,
              date_of_birth: dateOfBirth ? formatDate(dateOfBirth) : null,
              // martial_status:martialStatus
            },
          },
          hr_settings: {
            ...profileForm.hr_settings,
            work_details: {
              ...profileForm.hr_settings.work_details,
              user_branch: userBranch,
            },
          },
          job_details: [...tempData],
          payroll_settings: {
            ...profileForm.payroll_settings,
            identification_details: {
              ...profileForm.payroll_settings.identification_details,
              passport_expiry: passportExpiry
                ? formatDate(passportExpiry)
                : null,
            },
          },
          user_settings: {
            ...profileForm.user_settings,
          },
        };


        let finalData = { profileData: { ...newData }, token };
        dispatchUpdateProfile(finalData);
      }
    } else {
      if (
        !isEmailValid(profileForm?.user_details?.basic_details?.email_id) &&
        profileForm?.user_details?.basic_details?.email_id?.trim().length
      ) {
        setProfileDetailsError((prv) => ({
          ...prv,
          emailError: "Email not valid",
        }));
      }

      validation();
      setProfileDetailsError((prv) => ({
        ...prv,
        ...(!profileForm.user_details.basic_details.first_name?.trim() && {
          nameError: "First Name required",
        }),
        ...(!profileForm.user_details.basic_details.email_id?.trim() && {
          emailError: "Email required",
        }),
        ...(!profileForm.user_details?.current_address?.country?.value && {
          countryError: "Country required",
        }),
        ...(!profileForm.user_details?.current_address?.state?.value && {
          stateError: "State required",
        }),
        ...(!profileForm.user_details?.current_address?.city?.value && {
          cityError: "City required",
        }),
      }));
    }
  };
  function validation() {
    if (
      !profileForm.user_details.basic_details.first_name?.trim() ||
      !profileForm.user_details.basic_details.email_id?.trim()
    ) {
      return toast.error("Please fill all the mandatory values", {
        duration: 3500,
      });
    } else if (
      !isEmailValid(profileForm?.user_details?.basic_details?.email_id) &&
      profileForm?.user_details?.basic_details?.email_id?.trim().length
    ) {
      return toast.error("Email not valid", {
        duration: 3500,
      });
    }
  }
  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };
  const handleChangeCountry = (data: any) => {
    setCountry({
      value: data?.value,
      label: data?.label,
    });
  };
  const handleChangeState = (data: any) => {
    setAddressState({
      value: data?.value,
      label: data?.label,
    });
    // if (data?.value && profileDetailsError.stateError) {
    //   setProfileDetailsError((prevState: any) => ({
    //     ...prevState,
    //     stateError: "",
    //   }));
    // }
    // setProfileDetailsError((prevState: any) => ({
    //   ...prevState,
    //   cityError: "",
    // }));
  };
  const handleChangeCity = (data: any) => {
    setSelectedCityList({
      value: data?.value,
      label: data?.label,
    });
    // if (data?.value && profileDetailsError?.cityError) {
    //   setProfileDetailsError((prevState: any) => ({
    //     ...prevState,
    //     cityError: "",
    //   }));
    // }
  };
  const onlinePresenc = (e: any) => {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        user_details: {
          ...prv.user_details,
          online_presence: {
            ...prv.user_details.online_presence,
            [e.target.name]: e.target.value,
          },
        },
      };
    });
  };

  const handleCommunicationsDetails = (e: any) => {
    if (e.target.name === "mobile" && e.target.value.length) {
      const finalData = {
        token,
        operation: "update",
        mobile: e.target.value.trim(),
        email: null,
        user_id: user_id,
      };
      setUniqueMobileNo(finalData);
      dispatchResetMobileError();
      dispatchResetMobileMessage();
      dispatchResetMobileFetching();
      dispatchResetIsMobileNo();
    }
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        user_details: {
          ...prv.user_details,
          contact_details: {
            ...prv.user_details.contact_details,
            [e.target.name]: e.target.value,
          },
        },
      };
    });
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetAuthError();
              dispatchResetUsersProfileError();
              history.goBack();
            }}
          />
        );
      }
    } else if (
      success === 1 &&
      message?.includes("Finac user profile has been updated successfully!")
    ) {
      return (
        <ErrorSuccessModal
          type="success"
          isOpen={true}
          title="Success"
          message={"Profile Updated Successfully"}
          buttonText="OK"
          onPress={() => {
            dispatchResetAuthError();
            dispatchResetUsersProfileError();
            history.goBack();
          }}
        />
      );
    }

    return false;
  };

  return (
    <>
      <div className="col-md-6">
        <CommonHeader title="User Profile" />
      </div>
      <div className="col-md-12 mt-3">
        <div className="card p-3">
          <div className="mb-3">
            <h5 style={{ marginBottom: "20px" }}>User Profile Details</h5>
            <ProfilePhoto
              data={profileForm?.user_details}
              setProfileForm={setProfileForm}
              isEdit={true}
            />
          </div>
          <BasicDetails
            data={data?.user_details?.basic_details}
            setProfileForm={""}
            profileDetailsError={""}
          />
          <div className="row">
            <div className="col-md-3">
              <label htmlFor="employeeId">Employee ID</label>
              <input
                type="text"
                className="form-control"
                name="employee_id"
                value={isDefaultEmployee?.job_info?.employee_id}
                disabled={true}
              />
            </div>
            <div className="col-md-3">
              <label htmlFor="jobTitle">Job Title</label>
              <input
                type="text"
                className="form-control"
                disabled={true}
                name="job_title"
                value={isDefaultEmployee?.job_info?.job_title}
              />
            </div>
            <div className="col-md-3">
              <label htmlFor="department">Department</label>
              <Select
                options={[]}
                isDisabled
                value={{
                  value: isDefaultEmployee?.job_info?.department?._id,
                  label:
                    isDefaultEmployee?.job_info?.department?.department_name,
                }}
              />
            </div>
          </div>
          <div className="row mb-3">
            <div className="col-md-3">
              <label htmlFor="dateOfBirth">Start Date</label>
              <div className="d-flex flex-row position-relative">
                <div className="date-picker-wraper mr-0 w-100">
                  <Label className="mr-0 w-100">
                    <DatePicker
                      dateFormat="dd-MM-yyyy"
                      onChange={() => { }}
                      fixedHeight
                      showMonthDropdown
                      disabled
                      showYearDropdown
                      name="date_of_birth"
                      placeholderText="Select"
                      className="form-control"
                      selected={
                        isDefaultEmployee?.job_info?.start_date
                          ? new Date(
                            moment(
                              isDefaultEmployee?.job_info?.start_date,
                              "YYYY-MM-DD"
                            ).format("YYYY-MM-DD[T]HH:mm:ss")
                          )
                          : null
                      }
                    />
                    <span
                      className="calender-icon"
                      style={{
                        right: "20px",
                        top: "10px",
                        cursor: "pointer",
                      }}
                    >
                      <CalenderIcon />
                    </span>
                  </Label>
                </div>
              </div>
            </div>
            <div className="col-md-3">
              <label htmlFor="gender">Reporting Person</label>
              <Select
                className="dropdown"
                placeholder={"Search User"}
                options={[]}
                isDisabled
                value={{
                  value:
                    isDefaultEmployee?.reporting_details?.reporting_person
                      ?.user_id,
                  label:
                    reportingPersonFirstName + " " + reportingPersonLastName,
                }}
              />
            </div>
          </div>
          <LoggedInUserPersonalDetails
            data={profileForm?.user_details?.personal_details}
            isEdit
            handlePersonalDetails={handlePersonalDetails}
            setProfileForm={setProfileForm}
          />
          <LoggedInuserPersonalAddress
            data={profileForm?.user_details?.current_address}
            setProfileForm={setProfileForm}
            handleAddressDetails={handleAddressDetails}
            isState={isState}
            Option={Option}
            countrySelectedList={countrySelectedList}
            countryFetching={countryFetching}
            setCountryText={setCountryText}
            setCountryOffset={setCountryOffset}
            countrylimit={countrylimit}
            finalCountry={finalCountry}
            handleChangeCountry={handleChangeCountry}
            handleChangeState={handleChangeState}
            finalStateList={finalStateList}
            stateFetching={stateFetching}
            setStateText={setStateText}
            setStateOffset={setStateOffset}
            finalCityList={finalCityList}
            handleChangeCity={handleChangeCity}
            setCityOffset={setCityOffset}
            setCityText={setCityText}
            profileDetailsError={profileDetailsError}
            isCity={isCity}
          />

          <Communications
            data={profileForm?.user_details?.contact_details}
            setProfileForm={setProfileForm}
            mobileFetching={mobileFetching}
            mobileMessage={mobileMessage}
            handleCommunicationsDetails={handleCommunicationsDetails}
            isEdit={true}
            isMobileNo={isMobileNo}
            profileDetailsError={profileDetailsError}
          />
          <OnlinePresenc
            onlinePresenc={onlinePresenc}
            data={profileForm?.user_details?.online_presence}
            isEdit={true}
          />

          <FixedAssetDetails
            fixedAssetDetails={() => { }}
            data={data?.job_details}
          />
          <div className="row mt-3">
            <div className="col-md-12 d-flex justify-content-end ">
              <button
                className="btn ml-3"
                style={{ border: "1px solid #bfcbe1" }}
                onClick={() => {
                  history.push("/my-space");
                }}
              >
                Cancel
              </button>
              <button className="btn btn-primary ml-3" onClick={handleSubmit}
                disabled={(profileDetailsError?.emailError?.length ? true : false) || fetching || (mobileMessage && mobileMessage.includes("mobile") ? true : false)}>
                Save Changes
              </button>
            </div>
          </div>
        </div>
        {handleErrorModal()}
        <Toaster />
        {fetching && <Loader />}
      </div>
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  countryListTotalCount: state.masterData.countryListTotalCount,
  countryList: state.masterData.countryList,
  countryFetching: state.masterData.countryFetching,
  stateList: state.masterData.stateList,
  stateFetching: state.masterData.stateFetching,
  isState: state.masterData.isState,
  isCity: state.masterData.isCity,
  stateListTotalCount: state.masterData.stateListTotalCount,
  cityList: state.masterData.cityList,
  mobileMessage: state.auth.mobileMessage,
  mobileFetching: state.auth.mobileFetching,
  isMobileNo: state.auth.isMobileNo,
  fetching: state.usersProfile.fetching,
  statusCode: state.usersProfile.statusCode,
  error: state.usersProfile.error,
  success: state.usersProfile.success,
  message: state.usersProfile.message,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchUpdateProfile: (data: UserProfileType) =>
    dispatch(updateProfile(data)),
  dispatchGetCountryListAction: (data: GetCountryListDataPayloadType) =>
    dispatch(getAllCountryAction(data)),
  dispatchGetAllStateAction: (data: GetStateListDataPayloadType) =>
    dispatch(getAllStateAction(data)),
  dispatchGetAllCityAction: (data: GetCityListDataPayloadType) =>
    dispatch(getAllCityAction(data)),
  dispatchResetStateList: () => dispatch(resetStateList()),
  dispatchResetCityList: () => dispatch(resetCityList()),
  dispatchResetMobileError: () => dispatch(resetMobileError()),
  dispatchResetMobileMessage: () => dispatch(resetMobileMessage()),
  dispatchResetMobileFetching: () => dispatch(resetMobileFetching()),
  dispatchResetIsMobileNo: () => dispatch(resetIsMobileNo()),
  dispatchCheckUniqueMobileNoAction: (
    data: CheckUniquiEmailAndMobilePayloadType
  ) => dispatch(checkUniqueMobileNoAction(data)),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetAuthError: () => dispatch(resetAuthError()),
  dispatchResetUsersProfileError: () => dispatch(resetUsersProfileError()),
  dispatchResetUsersProfileMessage: () => dispatch(resetUsersProfileMessage()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoggedInUserProfileDetails);
